import { render, staticRenderFns } from "./TV.vue?vue&type=template&id=74d1e1ac"
import script from "./TV.vue?vue&type=script&lang=ts"
export * from "./TV.vue?vue&type=script&lang=ts"
import style0 from "./TV.vue?vue&type=style&index=0&id=74d1e1ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports